export default __webpack_public_path__ + "static/media/coresanscr95-webfont.10805be3.woff";